import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { addThirdPartyBillingAccountSet } from './addThirdPartyBilingAccountSet';
import { editThirdPartyBillingAccountSet } from './editThirdPartyBillingAccountSet';
export const workflows: WorkflowOptions[] = [
  addThirdPartyBillingAccountSet,
  editThirdPartyBillingAccountSet,
  ...Object.values(generateAssetStatusWorkflow('thirdPartyBillingAccountSet')),
];
export default workflows;
